import { createAction, createAsyncAction } from 'typesafe-actions';
import { JobInfo, GetJobsParams, JobModalType } from './types';

export const getJobsAsync = createAsyncAction(
  'jobs/GET_JOBS_REQUEST',
  'jobs/GET_JOBS_SUCCESS',
  'jobs/GET_JOBS_FAILURE',
)<GetJobsParams, { total: number; data: any[] }, Error>();

export const updateJobAsync = createAsyncAction(
  'jobs/UPDATE_JOB_REQUEST',
  'jobs/UPDATE_JOB_SUCCESS',
  'jobs/UPDATE_JOB_FAILURE',
)<JobInfo, {}, Error>();

export const addJobAsync = createAsyncAction('jobs/ADD_JOB_REQUEST', 'jobs/ADD_JOB_SUCCESS', 'jobs/ADD_JOB_FAILURE')<
  JobInfo,
  {},
  Error
>();

export const deleteJobAsync = createAsyncAction(
  'jobs/DELETE_JOB_REQUEST',
  'jobs/DELETE_JOB_SUCCESS',
  'jobs/DELETE_JOB_FAILURE',
)<{}, {}, Error>();

export const setJobs = createAction('jobs/SET_JOBS')<Array<JobInfo>>();
export const setJobModalType = createAction('jobs/SET_JOB_MODAL_TYPE')<JobModalType>();
export const setSelectedJob = createAction('jobs/SET_SELECTED_JOB')<JobInfo>();
export const setRefreshTable = createAction('jobs/SET_REFRESH_TABLE')<boolean>();
